module.exports = __webpack_public_path__ + "img/BB.92c3263c.png";